module.exports = __webpack_public_path__ + "img/elo-icon.8b8f0e1a.png";